import React from "react";
import { topCats, subCats, localName } from "../utils/helpers";

export default function UserPermissionsPanel({user,state,dispatch,t}){
  const {expenseCats,locations,lang}=state;
  const tops=topCats(expenseCats);
  const allowedCats=user.allowedCats||[];
  const allowedLocs=user.allowedLocs||[];
  const isOwner=user.role==="owner";

  const toggleCat=(id)=>{
    const all=allowedCats.includes(id)?allowedCats.filter(c=>c!==id):[...allowedCats,id];
    dispatch({type:"SET_USER_PERMS",id:user.id,allowedCats:all,allowedLocs});
  };
  const toggleLoc=(id)=>{
    const all=allowedLocs.includes(id)?allowedLocs.filter(l=>l!==id):[...allowedLocs,id];
    dispatch({type:"SET_USER_PERMS",id:user.id,allowedCats,allowedLocs:all});
  };

  if(isOwner) return(
    <div className="notice">
      <div className="notice-l">Owner Access</div>
      The owner has unrestricted access to all categories, locations, and data. Permissions cannot be restricted for this role.
    </div>
  );

  return(
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      {/* Expense categories */}
      <div className="card">
        <div className="ch">
          <div className="ct">Expense Categories</div>
          <div style={{fontSize:11,color:"var(--g400)"}}>
            {allowedCats.length===0?"All (unrestricted)":`${allowedCats.length} allowed`}
          </div>
        </div>
        <div style={{padding:"10px 16px"}}>
          <div style={{fontSize:11,color:"var(--g500)",marginBottom:10,lineHeight:1.5}}>
            Toggle which expense categories and subcategories this user can see and log expenses against. Empty = unrestricted.
          </div>
          {tops.map(cat=>{
            const subs=subCats(expenseCats,cat.id);
            const catAllowed=allowedCats.includes(cat.id);
            const catName2=localName(cat, lang);
            return(
              <div key={cat.id} style={{marginBottom:8}}>
                <div style={{display:"flex",alignItems:"center",gap:10,padding:"7px 10px",background:"var(--g50)",borderRadius:"var(--r)",marginBottom:3}}>
                  <div className={`toggle ${catAllowed?"on":""}`} onClick={()=>toggleCat(cat.id)}/>
                  <div style={{fontSize:13,fontWeight:600,color:"var(--ink)",flex:1}}>{catName2}</div>
                  <span style={{fontSize:10,color:"var(--g400)",fontFamily:"var(--fm)"}}>{subs.length} subcategories</span>
                </div>
                {catAllowed&&subs.map(sub=>{
                  const subAllowed=allowedCats.includes(sub.id);
                  const subName=localName(sub, lang);
                  return(
                    <div key={sub.id} style={{display:"flex",alignItems:"center",gap:10,padding:"5px 10px 5px 26px"}}>
                      <div className={`toggle ${subAllowed?"on":""}`} onClick={()=>toggleCat(sub.id)}/>
                      <div style={{fontSize:12,color:"var(--g600)",flex:1}}>{subName}</div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </div>

      {/* Locations */}
      <div className="card">
        <div className="ch">
          <div className="ct">Location Access</div>
          <div style={{fontSize:11,color:"var(--g400)"}}>
            {allowedLocs.length===0?"All (unrestricted)":`${allowedLocs.length} allowed`}
          </div>
        </div>
        <div style={{padding:"10px 16px"}}>
          <div style={{fontSize:11,color:"var(--g500)",marginBottom:10,lineHeight:1.5}}>
            Control which homes and locations appear in this user's dropdown menus. Empty = all locations visible.
          </div>
          {locations.map(loc=>{
            const locAllowed=allowedLocs.includes(loc.id);
            const locLabel=localName(loc, lang);
            return(
              <div key={loc.id} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",borderBottom:"1px solid var(--g100)"}}>
                <div className={`toggle ${locAllowed?"on":""}`} onClick={()=>toggleLoc(loc.id)}/>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:500,color:"var(--ink)"}}>{locLabel}</div>
                  <div style={{fontSize:11,color:"var(--g400)"}}>{loc.city} · {loc.type}</div>
                </div>
                {locAllowed&&<span className="pill p-done">Visible</span>}
                {!locAllowed&&<span className="pill p-low">Hidden</span>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
